module.exports = __webpack_public_path__ + "img/upperabs-endo-mesomorph-male.7d0c593a.svg";